export enum JobRepairNoteType {
  DESCRIPTION = 'DESCRIPTION',
  NOTE_RECEIVABLE = 'NOTE_RECEIVABLE',
  NOTE_BUMPOUT = 'NOTE_BUMPOUT',
}
